if (!customElements.get('product-bundle')) {
  class ProductBundle extends HTMLElement {
    /**
     * Section settings
     */
    sectionSettings;

    /**
     * Swiper entity
     * 
     * @type {Swiper}
     */
    mySwiper;

    constructor() {
      super();
      this.autoSelectOption = this.getAttribute("data-auto-select-option") == "true";
      window.addEventListener("DOMContentLoaded", () => {
        this.selectSameOption(document.querySelector("radio-swatch input:checked+label"));
      });
      if (this.autoSelectOption) {
        $("radio-swatch label").on("click", (e) => {
          const el = e.target;
          this.selectSameOption(el);
        });
      }
      document.addEventListener('theme:variant:change', (event) => this.updateItemsPrice());
    }

    /** bundle 产品跟随主产品的相同名称选项，自动切换到一样的选项 */
    selectSameOption(labelElement) {
      const value = labelElement.getAttribute("data-swatch");
      const bundleItems = this.querySelectorAll("product-bundle-item");
      for (const bundle of bundleItems) {
        const select = bundle.querySelector("select");
        const options = select.querySelectorAll("option");
        for (const option of options) {
          const optionValueList = option.innerText.trim().split('/');
          const findValue = optionValueList.find((v) => v.trim() == value.trim());
          if (findValue) {
            $(select).val(option.value);
            bundle.changeVariantIfAvailable(option.value);
          }
        }
      }
    }

    connectedCallback() {
      this.initOnlySwiper(0);
      this.addEventListener("click", (e) => {
        // Tab 大标题点击事件
        if (e.target?.matches(".product-bundle__tabs li")) {
          const tabIndex = e.target.getAttribute("data-index");
          // 已经在该标签下了，不执行任何操作
          if (e.target.classList.contains("active")) return;
          // 移除 active
          this.querySelector(".product-bundle__tabs li.active")?.classList.remove("active");
          this.querySelector(".swiper.active")?.classList.remove("active");
          // 添加 active
          this.querySelector(`.swiper[data-index="${tabIndex}"]`).classList.add("active");
          e.target.classList.add("active");
          // 重建 Swiper
          this.initOnlySwiper(tabIndex);
        }
      });
    }
    /**
     * 初始化指定 Tab 下的 Swiper，销毁其他 Tab 下的 Swiper
     * 
     * @param {*} tabIndex Tab的索引
     */
    initOnlySwiper(tabIndex) {
      this.mySwiper?.destroy();
      const containerSelector = `.swiper[data-index="${tabIndex}"]`;
      this.mySwiper = new Swiper(this.querySelector(`${containerSelector}`), {
        loop: false,
        slidesPerView: 'auto',
        observer: true,
        resizeObserver: true,
        navigation: {
          nextEl: this.querySelector(`.swiper-btn-next`),
          prevEl: this.querySelector(`.swiper-btn-prev`),
        },
        // pagination: {
        //   el: this.querySelector('.swiper-pagination'),
        //   clickable: true,
        // },
        scrollbar: {
          el: this.querySelector('.swiper-scrollbar'),
          draggable: true,
        },
        breakpoints: {
          750: {
            spaceBetween: 12,
          }
        },
      });
    }

    /** 更新所有子项的价格 */
    updateItemsPrice() {
      for (const item of this.querySelectorAll("product-bundle-item")) {
        item.updatePrice();
      }
    }
  }

  customElements.define('product-bundle', ProductBundle);
}

if (!customElements.get('product-bundle-item')) {
  class ProductBundleItem extends HTMLElement {
    constructor() {
      super();
      this.product = JSON.parse(this.getAttribute("data-product-json").replaceAll("/'", '"'));
      this.variant = this.product.variants.find((v) => v.available) ?? this.product.variants[0];
      this.productImage = this.querySelector("[data-product-image]");
      this.price = this.querySelector("[data-price]");
      this.comparePrice = this.querySelector("[data-compare-price]");
      this.select = this.querySelector("select");
      this.selectLabel = this.querySelector("[data-select-label]");
      this.addCartButton = this.querySelector("[data-add-cart-button]");
      this.bundlePriceLabel = this.querySelector("[data-bundle-price]");
      this.bundleComparePriceLabel = this.querySelector("[data-bundle-compare-price]");

      this.showDialogButtons = this.querySelectorAll("[data-show-dialog-button]");
      this.dialogWrapper = this.querySelector("[data-dialog-wrapper]");
      this.bundleId = `product-bundle-item__${new Date().getTime()}`;
      this.setAttribute("data-id", this.bundleId);
      this.dialogWrapper.setAttribute("data-id", this.bundleId);
      this.dialogWrapper.product = this.product;

      this.outerWrapper = this.closest("[data-section-id]");
      this.outerProductJSON = JSON.parse(this.outerWrapper.querySelector("[data-product-json]").innerHTML);
      this.outerVariantInput = this.outerWrapper.querySelector(`[data-product-form-outer] input[name="id"]`);
      this.outerQuantity = this.outerWrapper.querySelector("[data-quantity-input]");
      this.updatePrice();

      this.drawer = document.querySelector("[data-drawer='drawer-cart']");
      window.addEventListener("DOMContentLoaded", () => {
        document.body.appendChild(this.dialogWrapper);
        this.initEvent();
      });
    }

    initEvent() {
      this.select.addEventListener("change", (e) => {
        this.changeVariant(e.target.value);
      });
      this.addCartButton.addEventListener("click", (e) => {
        e.target.classList.add("loading");
        const mainVariantId = this.getParameterFromUrl("variant", window.location.href) ?? JSON.parse(document.querySelector("[data-product-json]").innerText).variants[0].id;
        this.addToCart([{ id: mainVariantId, quantity: 1 }, { id: this.select.value, quantity: 1 }]).then(() => {
          e.target.classList.remove("loading");
          if(this.drawer){

            this.drawer.dispatchEvent(
              new CustomEvent('theme:drawer:toggle', {
                bubbles: false,
              })
              
            );
          }
          document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
          monster_refresh(true);
        });
      });
      this.outerQuantity.addEventListener("change", (e) => {
        // const quantity = Number(e.target.value);
        this.updatePrice();
      });
      for (const el of this.showDialogButtons) {
        el.addEventListener("click", () => this.showDialog());
      }
    }

    showDialog() {
      this.dialogWrapper.setAttribute("data-dialog-open", true);
    }

    updatePrice(outerQuantity = 1) {
      const outerVariant = this.outerProductJSON.variants.find((v) => v.id == this.outerVariantInput.value);
      const outerPrice = outerVariant.price;
      const outerComparePrice = outerVariant.compare_at_price;
      const price = this.variant.price;
      const comparePrice = this.variant.compare_at_price;
      let bothPrice = (outerPrice + price) * outerQuantity;
      let bothComparePrice = ((outerPrice < outerComparePrice ? outerComparePrice : outerPrice) + (price < comparePrice ? comparePrice : price)) * outerQuantity;
      // Custom discount metaobject (buy 1 get 1 off)
      if (window.theme.discountMeta?.buy_1_get_1_off?.length) {
        const priceList = [];
        for (const metaItem of window.theme.discountMeta.buy_1_get_1_off) {
          if (metaItem.products_1.find(product => product.id == this.outerProductJSON.id && metaItem.products_2.find(product => product.id == this.product.id))) {
            // Bundle product off
            priceList.push(Math.ceil((outerPrice + price * (1 - metaItem.off)) * outerQuantity));
          }
          if (metaItem.products_1.find(product => product.id == this.product.id && metaItem.products_2.find(product => product.id == this.outerProductJSON.id))) {
            // Outer product off
            priceList.push(Math.ceil((outerPrice * (1 - metaItem.off) + price) * outerQuantity));
          }
        }
        if (priceList.length > 0) {
          bothPrice = Math.max(...priceList);
        }
      }

      // Custom discount metaobject (amount off products)
      if (window.theme.discountMeta?.amount_off_products_bundle?.length) {
        for (const metaItem of window.theme.discountMeta.amount_off_products_bundle) {
          if (metaItem.products_1.find(product => product.id == this.outerProductJSON.id && metaItem.products_2.find(product => product.id == this.product.id))) {
            bothPrice = Math.ceil(bothPrice * (1 - metaItem.off));
            break;
          }
          if (metaItem.products_1.find(product => product.id == this.product.id && metaItem.products_2.find(product => product.id == this.outerProductJSON.id))) {
            bothPrice = Math.ceil(bothPrice * (1 - metaItem.off));
            break;
          }
        }
      }
      this.bundlePriceLabel.innerHTML = this.formattingMoney(bothPrice);
      this.bundleComparePriceLabel.innerHTML = bothPrice < bothComparePrice ? this.formattingMoney(bothComparePrice) : '';
    }

    formattingMoney(money) {
      if (theme.settings.currency_code_enable) {
        return themeVendor.themeCurrency.formatMoney(money, theme.moneyFormat) + ` ${theme.currencyCode}`;
      } else {
        return themeVendor.themeCurrency.formatMoney(money, theme.moneyFormat);
      }
    }

    // 切换变体, 但只有变体未售罄才会切换
    changeVariantIfAvailable(variantId) {
      const variant = this.product.variants.find(v => v.id == variantId) ?? this.product.variants[0];
      if (variant && variant.available) {
        this.changeVariant(variantId);
      }
    }

    changeVariant(variantId) {
      this.selectLabel.innerText = this.select.selectedOptions[0].innerText.trim();
      const variant = this.product.variants.find(v => v.id == variantId) ?? this.product.variants[0];
      this.variant = variant;
      if (!variant) {
        console.error(`variant for id: ${variantId} not found.`);
        return;
      }
      let src = variant.featured_image.src ?? this.product.featured_image;
      src.includes('?') ? src += "&width=200" : src += "?width=200";
      this.productImage.src = src;
      this.price.innerHTML = themeVendor.themeCurrency.formatMoney(variant.price, theme.moneyFormat);
      if (variant.price < variant.compare_at_price) {
        this.comparePrice.innerHTML = themeVendor.themeCurrency.formatMoney(variant.compare_at_price, theme.moneyFormat);
      } else {
        this.comparePrice.innerHTML = "";
      }
      if (variant.available) {
        this.addCartButton.removeAttribute("disabled");
      } else {
        this.addCartButton.setAttribute("disabled", "");
      }
      this.updatePrice();
    }

    /**
     * 加购
     * @param {[{id: string, quantity: number}]} items 
     */
    async addToCart(items) {
      let formData = {
        'items': items
      };
      return fetch(window.Shopify.routes.root + "cart/add.js",
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData),
        }
      ).then((response) => {
        if (response.ok) {
          return response.json();
        }
      }).catch((err) => {
        console.error(err);
      });
    }

    getParameterFromUrl(name, url) {
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
  }

  customElements.define('product-bundle-item', ProductBundleItem);
}

if (!customElements.get('product-bundle-dialog')) {
  class ProductBundleDialog extends HTMLElement {
    constructor() {
      super();
      this.productBundleId = this.getAttribute("data-product-bundle-id");
      this.elements = {
        productBundleItem: document.querySelector(`[data-product-bundle-id="${this.productBundleId}"]`),
        dialogWrapper: this.querySelector("[data-dialog-wrapper]"),
        galleryContainer: this.querySelector(`[data-product-bundle-dialog-gallery-container`),
        closeDialogButton: this.querySelector("[data-close-dialog-button]"),
        select: this.querySelector("select"),
        selectLabel: this.querySelector("[data-select-label]"),
        priceLabel: this.querySelector("[data-price]"),
        comparePriceLabel: this.querySelector("[data-compare-price]"),
        thumbs: this.querySelectorAll("[data-bundle-media-thumbnail]"),
      };
      if (!this.product) {
        this.product = this.elements.productBundleItem.product;
      }
      this.variant = this.product.variants.find((v) => v.available) ?? this.product.variants[0];

      // this.updatePrice();
      this.initGallery();
      this.initEvent();
    }

    openDialog() {
      this.setAttribute("data-dialog-open", true);
    }

    closeDialog() {
      for (const video of this.querySelectorAll("video")) {
        if (!video.paused) {
          video.currentTime = 0;
          video.pause();
        }
      }
      this.removeAttribute("data-dialog-open");
    }

    initGallery() {
      this.gallerySwiper = new Swiper(this.elements.galleryContainer, {
        loop: true,
        spaceBetween: 0,
        centeredSlides: true,
        slidesPerView: 'auto',
        observer: true,
        resizeObserver: true,
        observeParents: true,
        allowTouchMove: false,
        breakpoints: {},
        navigation: {
          nextEl: this.querySelector('.swiper-btn-next'),
          prevEl: this.querySelector('.swiper-btn-prev'),
        },
      });
    }

    distoryGallery() {

    }

    initEvent() {
      this.elements.closeDialogButton.addEventListener("click", () => this.closeDialog());
      this.elements.select.addEventListener("change", (e) => {
        this.elements.selectLabel.innerText = e.target.selectedOptions[0].innerText.trim();
        this.changeVariant(e.target.value);
      });
      for (const thumb of this.elements.thumbs) {
        thumb.addEventListener("click", (e) => {
          const el = e.currentTarget;
          const index = Number(el.closest("[data-swiper-slide-index]").getAttribute("data-swiper-slide-index"));
          if (!isNaN(index)) {
            this.gallerySwiper.slideTo(index);
            this.querySelector("[data-bundle-media-thumbnail].is-activated").classList.remove("is-activated");
            el.classList.add("is-activated");
          } else {
            console.error("find thumb swiper slide index is NaN");
          }
        });
      }
    }

    changeVariant(variantId) {
      const variant = this.product.variants.find(v => v.id == variantId) ?? this.product.variants[0];
      this.variant = variant;
      if (!variant) {
        console.error(`variant for id: ${variantId} not found.`);
        return;
      }
      this.updatePrice();
    }

    updatePrice() {
      const price = this.variant.price;
      const comparePrice = this.variant.compare_at_price;
      this.elements.priceLabel.innerHTML = this.formattingMoney(price);
      this.elements.comparePriceLabel.innerHTML = price < comparePrice ? this.formattingMoney(comparePrice) : '';
    }

    formattingMoney(money) {
      if (theme.settings.currency_code_enable) {
        return themeVendor.themeCurrency.formatMoney(money, theme.moneyFormat) + ` ${theme.currencyCode}`;
      } else {
        return themeVendor.themeCurrency.formatMoney(money, theme.moneyFormat);
      }
    }
  }

  customElements.define('product-bundle-dialog', ProductBundleDialog);
}